export const collections = [
	{
		id: 0,
		name: "Fuck 2016",
		thumbnail: "./public/thumbnails/thumbnail_Fuck2016.jpg",
		id_default: 395854478,
		id_men: 395854478,
		id_women: 395856654,
		id_misc: 395857102,
		subNav: true
	},
	{
		id: 1,
		name: "Not My Fucking President",
		thumbnail: "./public/thumbnails/thumbnail_NMFP.jpg",
		id_default: 395856654,
		id_men: 30389731382,
		id_women: 30389764150,
		id_misc: 30389698614,
		subNav: true
	},
	{
		id: 2,
		name: "The Black Square",
		thumbnail: "./public/thumbnails/thumbnail_black_square.jpg",
		id_default: 30391566390,
		subNav: false
	},
	{
		id: 3,
		name: "The Red Triangle",
		thumbnail: "./public/thumbnails/thumbnail_red_triangle.jpg",
		id_default: 30391631926,
		subNav: false
	},
	{
		id: 4,
		name: "The Blue Circle",
		thumbnail: "./public/thumbnails/thumbnail_blue_circle.jpg",
		id_default: 30391664694,
		subNav: false
	}
]




// WEBPACK FOOTER //
// ./src/store/constants/shopCollections.js